exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".component.youtube iframe,\n.component.youtube .cover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\n.component.youtube iframe {\n  border: none;\n  display: none;\n  display: block; }\n\n.component.youtube .cover {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  transition: opacity 0.2s;\n  pointer-events: none; }\n\n.component.youtube[data-status=\"playing\"] .cover, .component.youtube[data-status=\"paused\"] .cover {\n  opacity: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/youtube/youtube.scss
// module id = 180
// module chunks = 0